import { TranslatePipe } from '../../../filters/translate.pipe';
import { LoaderOverlayComponent } from '../../../components/loader-overlay/loader-overlay.component';
import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import AngularRoutingHelperService from '../../../services/angular-routing-helper.service';
import RoutingService from '../../../services/routing.service';
import XRoadConsentRestServices from '../../../services/x-road-consent-rest.service';
import Toast from '../../../services/toast.service';
import AngularFilterHelperService from '../../../services/angular-filter-helper.service';

@Component({
	standalone: true,
	selector: 'x-road-consent-service',
	templateUrl: './x-road-consent-service.component.html',
	imports: [ CommonModule, TranslatePipe, LoaderOverlayComponent, FormsModule ]
})
export default class XRoadConsentServiceComponent implements OnInit {
	private angularRoutingHelperService: AngularRoutingHelperService = inject(AngularRoutingHelperService);
	private routingService: RoutingService = inject(RoutingService);
	private xRoadConsentRestServices: XRoadConsentRestServices = inject(XRoadConsentRestServices);
	private toast: Toast = inject(Toast);
	private angularFilterHelperService: AngularFilterHelperService = inject(AngularFilterHelperService);
	
	vm: any = undefined;
	
	constructor() {
		this.vm = this;
	}
	
	ngOnInit() {
		this.vm.loading = false;
		this.routingService.validateAccess('consents').then(() => {
			var params: any = this.angularRoutingHelperService.getQueryParams() || {};
			return this.xRoadConsentRestServices.getXRoadConsentServiceRedirectUrl({ callbackUrl: params['comingFrom'] })
				.then(
					(redirectDto) => {
						this.vm.redirectDto = redirectDto;
						this.loadUserValidConsents();
					}
				).catch(this.consentServiceFailed);
		});
	}
	
	consentServiceFailed() {
		this.toast.showAsync(this.angularFilterHelperService.translate('XRoadConsentService.Consent_Service_Failed'), null, null, 'error');
		this.loadUserValidConsents();
	}
	
	loadUserValidConsents() {
		this.xRoadConsentRestServices.getUserValidXRoadConsents()
			.then(
				(userConsentsDto) => {
					this.vm.userConsentsDto = userConsentsDto;
					this.onResolve();
				}
			);
	}
	
	onResolve() {
		this.vm.params = this.angularRoutingHelperService.getQueryParams() || {};
		this.vm.goToRedirectUrl = this.goToRedirectUrl;
	}
	
	goToRedirectUrl() {
		window.location.href = this.vm.redirectDto.url;
	}
	
}